import { ContentfulModel } from '@/types/contentful'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { createClient } from 'contentful'

export const contentfulClient = createClient({
  space: import.meta.env.VITE_CONTENTFUL_SPACE_ID,
  accessToken: import.meta.env.VITE_CONTENTFUL_TOKEN,
  environment: import.meta.env.VITE_CONTENTFUL_ENVIRONMENT,
})

type Document = {
  nodeType?: any
  title?: any
  content?: any
  data?: any
}

export const getLatestByContentType = async (contentType: string) => {
  const response = await contentfulClient.getEntries({
    content_type: contentType,
    order: '-sys.updatedAt' as any,
    limit: 1,
    'metadata.tags.sys.id[in]': 'customerPortal' as any,
  })

  if (response.items[0]) {
    return {
      title: response.items[0].fields.title,
      content: documentToHtmlString(
        (response.items[0].fields as Document).content
      ),
      contentPostId: response.items[0].sys.id,
      updatedDate: response.items[0].sys.updatedAt,
    } as ContentfulModel
  }

  return null
}
